module.exports = __webpack_public_path__ + "static/media/trainings_group_somatic_exercise_mindful_movement.422ce94e.webp";